const preloadedTypes = {
  number: require('@/core/input-types/number.js'),
};

const clean = value => value.replace(/(\s|-|\\|\/|_)/g, '');

const getTypeValidator = async function (t) {
  if (preloadedTypes[t]) {
    return preloadedTypes[t];
  }

  try {
    const module = await import(`@/core/input-types/${t}.js`);
    return module;
  } catch (e) {
    // this is expected if input has no config
    return {};
  }
};

// const presetCustomTypes = ['EMAIL', 'PASSWORD_SIMPLE', 'PASSWORD_COMPLEX', 'ADDRESS_AU'];
const presetTypes = ['SELECT', 'CHECK', 'RADIO', 'LINK', 'LINK_BUTTON'];
const baseTypes = ['STRING', 'PASSWORD', 'NUMBER', 'TEXT'];

const typeTranslation = type => {
  if (!type) {
    return 'text';
  }

  if (baseTypes.includes(type)) {
    if (type === 'NUMBER') {
      return {
        type: 'number',
        validation: type.toLowerCase(),
      };
    }

    if (type === 'STRING') {
      return 'text';
    }

    return type.toLowerCase();
  }

  if (presetTypes.includes(type)) {
    return type.toLowerCase();
  }

  // preset password types
  if (type.indexOf('PASSWORD') > -1) {
    return {
      type: 'password',
      validation: type.toLowerCase(),
    };
  }

  // // preset phone types
  // if (type.indexOf('PHONE') > -1) {
  //   return {
  //     type: 'phone',
  //   };
  // }

  // preset address types
  if (type.indexOf('ADDRESS') > -1) {
    return {
      type: 'address',
      validation: type.toLowerCase(),
    };
  }

  // custom types
  return {
    type: 'text',
    validation: type.toLowerCase(),
  };
};

export { clean, getTypeValidator, typeTranslation };
